/* Adresses des vidéos et affiches téléversées dans Shopify (Contenu > Fichiers), 19/10/2026. */
OO.config.media = {
  "m1.mp4": "https://cdn.shopify.com/videos/c/o/v/4537432940e042e080a3b6b124bfbd97.mp4",
  "m1.jpg": "https://cdn.shopify.com/s/files/1/1111/7212/5062/files/oo-affiche-m1.jpg?v=1792424482",
  "m2.mp4": "https://cdn.shopify.com/videos/c/o/v/e43a37e424d6416da7fc8335c4781c5b.mp4",
  "m2.jpg": "https://cdn.shopify.com/s/files/1/1111/7212/5062/files/oo-affiche-m2.jpg?v=1792424482",
  "m3.mp4": "https://cdn.shopify.com/videos/c/o/v/c6cc5489307e4e98ad18fee243acb037.mp4",
  "m3.jpg": "https://cdn.shopify.com/s/files/1/1111/7212/5062/files/oo-affiche-m3.jpg?v=1792424483",
  "m4.mp4": "https://cdn.shopify.com/videos/c/o/v/84614a14199948fbad4dceb8ba92db09.mp4",
  "m4.jpg": "https://cdn.shopify.com/s/files/1/1111/7212/5062/files/oo-affiche-m4.jpg?v=1792424482",
  "m5.mp4": "https://cdn.shopify.com/videos/c/o/v/054cf04e841b466f84416b71766c4962.mp4",
  "m5.jpg": "https://cdn.shopify.com/s/files/1/1111/7212/5062/files/oo-affiche-m5.jpg?v=1792424482",
  "m6.mp4": "https://cdn.shopify.com/videos/c/o/v/3c2b4d1e87454cf6925f3f0176223e73.mp4",
  "m6.jpg": "https://cdn.shopify.com/s/files/1/1111/7212/5062/files/oo-affiche-m6.jpg?v=1792424482",
  "m7.mp4": "https://cdn.shopify.com/videos/c/o/v/0452d7839347444ea2e8c99c581e988c.mp4",
  "m7.jpg": "https://cdn.shopify.com/s/files/1/1111/7212/5062/files/oo-affiche-m7.jpg?v=1792424482",
  "m8.mp4": "https://cdn.shopify.com/videos/c/o/v/3b361a84e5004a09891127367b4d3333.mp4",
  "m8.jpg": "https://cdn.shopify.com/s/files/1/1111/7212/5062/files/oo-affiche-m8.jpg?v=1792424482"
};
OO.config.credits = "Polices Poppins et Lora (SIL Open Font License). Voix off des vidéos générée avec ElevenLabs.";
